// extracted by mini-css-extract-plugin
export default {"header":"ProgramMainMedicinesTable_header__WAvc2","add":"ProgramMainMedicinesTable_add__XX1wQ","cogwheel":"ProgramMainMedicinesTable_cogwheel__VIMPk"};